import React from 'react';
import Login from './Login';
import '../App.css';

const LandingPage = ({ onLogin }) => {
    return (
        <div className="landing-page">
            <div className="hero-text-center">
                <h1>Turn Instagram Interactions<br />Into <span className="gradient-text">Sales</span></h1>
                <p>The smartest automation engine for Instagram merchants.</p>
            </div>

            <div className="landing-split-content">
                <div className="process-grid">
                    <div className="process-card">
                        <span className="p-icon">📝</span>
                        <div className="process-content">
                            <h4>1. Sign Up</h4>
                            <p>Create free account</p>
                        </div>
                    </div>
                    <div className="process-card">
                        <span className="p-icon">📤</span>
                        <div className="process-content">
                            <h4>2. Add Catalog</h4>
                            <p>Upload your products</p>
                        </div>
                    </div>
                    <div className="process-card">
                        <span className="p-icon">🔗</span>
                        <div className="process-content">
                            <h4>3. Link Instagram</h4>
                            <p>Connect your page</p>
                        </div>
                    </div>
                    <div className="process-card">
                        <span className="p-icon">📸</span>
                        <div className="process-content">
                            <h4>4. Create Post</h4>
                            <p>Share on Instagram</p>
                        </div>
                    </div>
                    <div className="process-card">
                        <span className="p-icon">⚡</span>
                        <div className="process-content">
                            <h4>5. Auto-DM</h4>
                            <p>We send purchase links</p>
                        </div>
                    </div>
                    <div className="process-card">
                        <span className="p-icon">💌</span>
                        <div className="process-content">
                            <h4>6. Get Paid</h4>
                            <p>Track your revenue</p>
                        </div>
                    </div>
                </div>

                <div className="landing-auth">
                    <div className="login-card-glass">
                        <h2>Get Started</h2>
                        <p>Sign in to access your dashboard</p>
                        <Login onLogin={onLogin} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LandingPage;
